<template>
  <div>
  <div :inert="guideActive ? '' : null" :aria-hidden="guideActive ? 'true' : null" data-client-portal-shell>
    <sidebar ref="sidebar" @show-guide="replayGuide" @mobile-menu-change="mobileMenuOpen = $event" />
    <div class="relative client-main-content bg-blueGray-100 min-h-screen" :inert="mobileMenuOpen ? '' : null">
      <admin-navbar />
      <header-stats />

      <div class="px-4 md:px-10 mx-auto w-full dashboard-content-wrap">
        <router-view />
        <footer-admin />
      </div>
    </div>
  <mobile-navigation v-if="isClientPortal" :inactive="mobileMenuOpen" />
  </div>
  <client-guide v-if="isClientPortal" ref="guide" @active-change="guideVisibilityChanged" @prepare-step="prepareGuideStep" />
  </div>
</template>

<script>
import AdminNavbar from "@/components/Navbars/AdminNavbar.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import HeaderStats from "@/components/Headers/HeaderStats.vue";
import FooterAdmin from "@/components/Footers/FooterAdmin.vue";
import ClientGuide from "@/components/Guide/ClientGuide.vue";
import MobileNavigation from "@/components/Mobile/MobileNavigation.vue";
import "@/assets/styles/mobile.css";

export default {
  name: "admin-layout",
  data: () => ({ guideActive: false, mobileMenuOpen: false }),
  computed: {
    isClientPortal() { return !['vendor', 'coordinator'].includes(localStorage.getItem('user_type')); },
  },
  methods: {
    replayGuide() { this.$refs.guide?.requestReplay(); },
    guideVisibilityChanged(active) {
      this.guideActive = active;
      if (active) this.$refs.sidebar?.beginGuide(); else this.$refs.sidebar?.endGuide();
    },
    prepareGuideStep(section) { this.$refs.sidebar?.prepareGuideStep(section); },
  },
  components: {
    AdminNavbar,
    Sidebar,
    HeaderStats,
    FooterAdmin,
    ClientGuide,
    MobileNavigation,
  },
};
</script>

<style scoped>
.dashboard-content-wrap {
  position: relative;
  z-index: 10;
  margin-top: 1rem;
  padding-bottom: 2rem;
}

@media (min-width: 768px) {
  .dashboard-content-wrap {
    margin-top: 1.5rem;
  }
}
</style>
